import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Craig B.",
    role: "Shell Garage Franchisee",
    location: "Cape Town",
    rating: 5,
    text: "Running a petrol station means high-volume transactions daily. Their bookkeeping is meticulous and my SARS compliance has never been cleaner. Highly recommend.",
  },
  {
    name: "Leon F.",
    role: "Shell Service Station Franchisee",
    location: "Cape Town",
    rating: 5,
    text: "Managing fuel sales, shop inventory, and staff payroll is complex. They understand the petrol station business and keep everything compliant with zero stress.",
  },
  {
    name: "Ayesha M.",
    role: "Dermatologist",
    location: "Cape Town",
    rating: 5,
    text: "They handle our payroll for 12 staff, VAT, and all SARS submissions. As a busy practice, I need reliability — and they deliver every month without fail.",
  },
  {
    name: "Eugene V.",
    role: "Coffee Shop Owner",
    location: "Cape Town",
    rating: 5,
    text: "I opened my second branch and needed proper books fast. They had me set up within a week — payroll, UIF, everything. Worth every cent.",
  },
  {
    name: "Abdulla J.",
    role: "Pharmacy Owner",
    location: "Cape Town",
    rating: 5,
    text: "Switched from doing my own books and it's been a game-changer. Professional, affordable, and they actually explain things in plain language.",
  },
  {
    name: "Keane H.",
    role: "Architect",
    location: "Cape Town",
    rating: 5,
    text: "Managing a practice is demanding enough. They take care of all the financials so I can focus on my projects. Couldn't ask for better service.",
  },
];

export function Testimonials() {
  return (
    <section className="py-20 lg:py-28 section-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-medium text-primary mb-3 tracking-wide uppercase">
            Client Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-4">
            Trusted by Businesses Across South Africa
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-card rounded-lg border border-border p-5 hover:shadow-md transition-shadow"
            >
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-accent flex items-center justify-center text-xs font-bold text-primary">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground leading-tight">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.role} · {t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export const reviewSchema = {
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "name": "Bookkeeping Services South Africa",
  "url": "https://bookkeepingservices.co.za",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": String(testimonials.length),
    "reviewCount": String(testimonials.length),
  },
  "review": testimonials.map((t) => ({
    "@type": "Review",
    "author": { "@type": "Person", "name": t.name },
    "reviewRating": { "@type": "Rating", "ratingValue": String(t.rating), "bestRating": "5" },
    "reviewBody": t.text,
  })),
};
